<template>
  <div class="createSchool" v-if="tag === 'normal'">
    <div class="header">创建学校</div>
    <div class="logo">
      <span class="text">学校logo</span>
      <div class="logoImg" v-if="logo.localUrl != '' " :style="`background-image:url(${logo.localUrl})`">
          <div class="logoImgShadow" v-if="logo.remoteUrl === '' ">
            <span
              class="logoImgProgress"
              v-if="logo.progress !== 100"
            >{{logo.progress === -1?"上传失败":logo.progress+"%"}}</span>
          </div>
        </div>

      <span class="upload" @click="uploadPhoto()">
        <span class="line1"></span>
        <span class="line2"></span>
      </span>
      
      <input
        ref="uploadPhoto"
        required
        accept="image/*"
        type="file"
        style="display:none;"
        @change="uploadPhoto_change"
      />
    </div>
    <div class="SchoolName">
      <span class="text">学校名称</span>
      <div class="input">
        <input required placeholder="学校名称(16字以内)" v-model="name" @input="inputEvent('name')"/>
      </div>
    </div>
    <div class="SchoolIntro">
      <span class="text">学校介绍</span>
      <div class="textarea">
        <textarea
          required=""
          placeholder="学校介绍(100字以内)"
          v-model="content"
          @input="inputEvent('content')"
        ></textarea>
      </div>
    </div>
    <span class="submit" @click="submit()">确认</span>
  </div>
  <div v-else-if="show_shadow_view" class="createSchoolShadow" @click.self="hideShadowView()">
    <div class="createSchoolView">
      <span class="close" @click="hideShadowView()">
        <span class="line1"></span>
        <span class="line2"></span>
      </span>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { UPLOAD_SINGLE_IMAGE } from '@/utils';
// @ is an alias to /src

import { types as ToastTypes } from "@/store/modules/toast";
import { types as SchoolTypes } from "@/store/modules/school";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "SchoolCreate",
  components: {},
  props: {
    tag: {
      type: String,
      default: 'normal'
    },
    currentSchool:{
      type: Object,
      default: null
    }
  },
  data() {
    return {
      name: "",
      content: "",
      logo: {
        localUrl:"",
        progress:0,
        remoteUrl:""
      },
      show_shadow_view: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW
    }),
    ...mapActions({
      fetchCreateSchool: SchoolTypes.FETCH_CREATE_SCHOOL,
      fetchUpdateSchool: SchoolTypes.FETCH_UPDATE_SCHOOL
    }),

    // 上传 logo 图点击事件
    uploadPhoto(){
      this.$refs.uploadPhoto.click();
    },
    uploadPhoto_change(e){
      let files = e.target.files;
      let imgSrc = window.URL.createObjectURL(files[0]);
      this.logo.localUrl = imgSrc;

      UPLOAD_SINGLE_IMAGE(files[0], (url)=>{
        this.logo.remoteUrl = url;
      }, (progress)=>{
        this.logo.progress = parseInt(progress);
      })
    },
    // input 事件
    inputEvent(tag){
      if(tag === 'content' && this.content.length > 100){
        this.showToast({"message":"请将介绍字数控制在100字以内"})
        this.content = this.content.slice(0, 100);
        return
      }
      if(tag === 'name' && this.name.length > 16){
        this.showToast({"message":"请将名称控制在16字以内"})
        this.name = this.name.slice(0, 16);
        return
      }
    },
    // 确定事件
    submit(){
      if(this.logo.remoteUrl === ""){
        this.showToast({"message":"请上传学校logo"})
        return
      }
      if(this.name === ""){
        this.showToast({"message":"请输入学校名称"})
        return
      }
      if(this.content === ""){
        this.showToast({"message":"请输入学校介绍"})
        return
      }

      if(this.content.length > 100){
        this.showToast({"message":"请将介绍字数控制在100字以内"})
        return
      }
      if(this.name.length > 16){
        this.showToast({"message":"请将名称控制在16字以内"})
        return
      }

      let data = {
        "name": this.name,
        "content": this.content,
        "logo": this.logo.remoteUrl
      }
      if(this.currentSchool){
        // 修改公司
        console.log("修改学校");
        data["pk"] = this.currentSchool.id;
        this.fetchUpdateSchool(data)
      }else{
        // 新建公司
        console.log("新建学校");
        this.fetchCreateSchool(data);
      }
      
      if(this.$parent.hideShadowView){
        this.$parent.hideShadowView()
      }
    },

    // -----shadow 事件
    showShadowView(){
      this.show_shadow_view = true
    },
    hideShadowView(){
      this.show_shadow_view = false
    },
  },
  created() {},
  destroyed() {},
  mounted() {
    if(this.currentSchool){
      this.name = this.currentSchool.name;
      this.content = this.currentSchool.content;
      this.logo.remoteUrl = this.currentSchool.logo;
      this.logo.localUrl = this.currentSchool.logo;
    }
  }
};
</script>

<style lang="less" scoped>
.createSchool {
  background-color: #644ed9;
  border: solid 3px #ffffff;
  padding: 25px;
  padding-top: 15px;
  border-radius: 10px;
  overflow: hidden;
  .header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 30px;
    margin-bottom: 15px;
    color: #ffffff;
    font-size: 20px;
  }
  .logo {
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;
    .text {
      margin-right: 10px;
      color: #ffffff;
      font-size: 14px;
    }
    .logoImg{
      width: 60px;
      height: 60px;
      margin-right: 10px;
      position: relative;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      .logoImgShadow{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
        position: relative;

        display: flex;
        justify-content: center;
        align-items: center;
        .logoImgProgress{
          color: #ffffff;
          font-size: 20px;
        }
      }
    }
    .upload {
      width: 60px;
      height: 60px;
      border-radius: 5px;
      background-color: #ffffff;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .line1 {
        position: absolute;
        width: 35px;
        height: 2px;
        background-color: #644ed9;
        top: 50%;
      }
      .line2 {
        width: 2px;
        height: 35px;
        background-color: #644ed9;
      }
    }
  }
  .SchoolName {
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;
    .text {
      margin-right: 10px;
      color: #ffffff;
      font-size: 14px;
    }
    .input {
      flex: 1;
      height: 35px;
      background-color: #ffffff;
      border-radius: 5px;
      overflow: hidden;
      padding: 0 10px;
      input {
        border: none;
        width: 100%;
        height: 100%;
      }
    }
  }
  .SchoolIntro {
    display: flex;
    flex-direction: row;
    margin-bottom: 25px;
    .text {
      margin-right: 10px;
      color: #ffffff;
      font-size: 14px;
    }
    .textarea {
      flex: 1;
      height: 80px;
      background-color: #ffffff;
      border-radius: 5px;
      overflow: hidden;
      padding: 10px;
      textarea {
        border: none;
        width: 100%;
        height: 100%;
      }
    }
  }
  .submit {
    width: 70px;
    height: 30px;
    border-radius: 15px;
    background-color: #f1923c;
    color: #ffffff;
    font-size: 14px;
    display: inline-block;
    line-height: 30px;
    text-align: center;
    margin-left: calc(50% - 35px);
    cursor: pointer;
  }
}
.createSchoolShadow{
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  position: fixed;
  overflow: auto;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .createSchoolView{
    width: 60%;
    border-radius: 5px;
    // overflow: hidden;
    position: relative;
    .close {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #ffffff;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: absolute;
      right: -50px;
      top:0;
      transform: rotate(45deg);
      .line1 {
        position: absolute;
        width: 20px;
        height: 1.5px;
        background-color: #644ed9;
        top: calc(50% - 1px);
      }
      .line2 {
        width: 1.5px;
        height: 20px;
        background-color: #644ed9;
      }
    }
  }
}
</style>
